let dynamicControllers = ["part_ui_input", "part_ui_select", "wsw", "part_cookieconsent", "part_form_cookieconsent"];
let dynamicActions = [];

const application = Stimulus.Application.start(document.documentElement, {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target"
});

importScript.used = [];
importScript.loaded = [];

if (document.body.classList.contains("preload")) {
    cssLoaded(function () {
        document.body.classList.remove("preload");
    });
}

document.body.insertAdjacentHTML("beforeend", '<button id="bg"></button>');

if(document.querySelector("#form")) {
    setTimeout(function () {
        document.querySelector("#form").insertAdjacentHTML("beforeend",'<input name="antispam" value="antispam" type="hidden" />');
    }, 2500);
}